import DefaultLayout from "../component/Layout/DefaultLayout";
import WelcomeMiConalep from "../component/Welcome/WelcomePage";

export default function WelcomeMiConalepLayout() {
    return (
        <DefaultLayout>
            <WelcomeMiConalep />
        </DefaultLayout>
    );
}